export default __webpack_public_path__ + "static/media/1.a996ea97.png";